/* eslint-disable */
// ============================================================
//  UI POPUPS — InstallAppPopup + CookieBanner
//  Extraits de ui.jsx (qui passait de 2134 à ~1505 lignes) le
//  1 juin 2026. Ces 2 popups sont autonomes (n'utilisent que
//  useState, useEffect et le composant Header), donc parfaits
//  pour une extraction propre.
//  ui.jsx ré-exporte ces deux composants → 0 changement pour
//  les consommateurs qui font `import { InstallAppPopup }
//  from "./ui"`.
// ============================================================

import { useState, useEffect } from "react";
import { Header } from "./ui";

import { LOGO } from "./constants";

const INSTALL_TEXTS = {
  fr: {
    title: "🐴 Hop ! Ajoute-moi !",
    subtitle1: "Mets HorseConnex sur ton écran d'accueil",
    subtitle2: "comme une vraie app ! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Tape sur le menu ⋮ en haut à droite de ton navigateur',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Choisis ',
    androidStep2bold: '"Ajouter à l\'écran d\'accueil"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Confirme avec ',
    stepFinalBold: '"Ajouter"',
    stepFinalPost: " et c'est fini ! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Important",
    iosWarningMid: " : utilise ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (pas Chrome) sur iPhone",
    iosStep1Pre: 'Tape sur le bouton ',
    iosStep1Bold: "Partager",
    iosStep1Post: " en bas ⬆️",
    iosStep2Pre: 'Fais défiler et choisis ',
    iosStep2Bold: '"Sur l\'écran d\'accueil"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Pourquoi installer ?",
    benefit1: "✓ Accès rapide depuis ton écran d'accueil",
    benefit2: "✓ S'ouvre comme une vraie app",
    benefit3: "✓ Plus besoin de naviguer dans le navigateur",
    later: "Plus tard",
    gotIt: "J'ai compris ✓"
  },
  en: {
    title: "🐴 Hey! Add me!",
    subtitle1: "Put HorseConnex on your home screen",
    subtitle2: "like a real app! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Tap the ⋮ menu at the top right of your browser',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Choose ',
    androidStep2bold: '"Add to home screen"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Confirm with ',
    stepFinalBold: '"Add"',
    stepFinalPost: " and you're done! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Important",
    iosWarningMid: ": use ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (not Chrome) on iPhone",
    iosStep1Pre: 'Tap the ',
    iosStep1Bold: "Share",
    iosStep1Post: " button at the bottom ⬆️",
    iosStep2Pre: 'Scroll down and choose ',
    iosStep2Bold: '"Add to Home Screen"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Why install?",
    benefit1: "✓ Quick access from your home screen",
    benefit2: "✓ Opens like a real app",
    benefit3: "✓ No more browser navigation",
    later: "Later",
    gotIt: "Got it ✓"
  },
  de: {
    title: "🐴 Hey! Füg mich hinzu!",
    subtitle1: "Setz HorseConnex auf deinen Startbildschirm",
    subtitle2: "wie eine echte App! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Tippe auf das ⋮-Menü oben rechts in deinem Browser',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Wähle ',
    androidStep2bold: '"Zum Startbildschirm hinzufügen"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Bestätige mit ',
    stepFinalBold: '"Hinzufügen"',
    stepFinalPost: " und fertig! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Wichtig",
    iosWarningMid: ": Nutze ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (nicht Chrome) auf dem iPhone",
    iosStep1Pre: 'Tippe auf den ',
    iosStep1Bold: "Teilen",
    iosStep1Post: "-Button unten ⬆️",
    iosStep2Pre: 'Scrolle nach unten und wähle ',
    iosStep2Bold: '"Zum Home-Bildschirm"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Warum installieren?",
    benefit1: "✓ Schneller Zugriff vom Startbildschirm",
    benefit2: "✓ Öffnet sich wie eine echte App",
    benefit3: "✓ Keine Browser-Navigation mehr nötig",
    later: "Später",
    gotIt: "Verstanden ✓"
  },
  es: {
    title: "🐴 ¡Eh! ¡Añádeme!",
    subtitle1: "Pon HorseConnex en tu pantalla de inicio",
    subtitle2: "¡como una app real! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Toca el menú ⋮ arriba a la derecha de tu navegador',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Elige ',
    androidStep2bold: '"Añadir a la pantalla de inicio"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Confirma con ',
    stepFinalBold: '"Añadir"',
    stepFinalPost: " ¡y listo! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Importante",
    iosWarningMid: ": usa ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (no Chrome) en iPhone",
    iosStep1Pre: 'Toca el botón ',
    iosStep1Bold: "Compartir",
    iosStep1Post: " abajo ⬆️",
    iosStep2Pre: 'Desplázate y elige ',
    iosStep2Bold: '"Añadir a pantalla de inicio"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ ¿Por qué instalar?",
    benefit1: "✓ Acceso rápido desde tu pantalla de inicio",
    benefit2: "✓ Se abre como una app real",
    benefit3: "✓ Ya no necesitas navegar por el navegador",
    later: "Más tarde",
    gotIt: "Entendido ✓"
  },
  it: {
    title: "🐴 Ehi! Aggiungimi!",
    subtitle1: "Metti HorseConnex sulla tua schermata home",
    subtitle2: "come una vera app! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Tocca il menu ⋮ in alto a destra nel tuo browser',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Scegli ',
    androidStep2bold: '"Aggiungi alla schermata Home"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Conferma con ',
    stepFinalBold: '"Aggiungi"',
    stepFinalPost: " e hai finito! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Importante",
    iosWarningMid: ": usa ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (non Chrome) su iPhone",
    iosStep1Pre: 'Tocca il pulsante ',
    iosStep1Bold: "Condividi",
    iosStep1Post: " in basso ⬆️",
    iosStep2Pre: 'Scorri e scegli ',
    iosStep2Bold: '"Aggiungi a Home"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Perché installare?",
    benefit1: "✓ Accesso rapido dalla schermata home",
    benefit2: "✓ Si apre come una vera app",
    benefit3: "✓ Non serve più navigare nel browser",
    later: "Più tardi",
    gotIt: "Capito ✓"
  },
  pt: {
    title: "🐴 Olá! Adiciona-me!",
    subtitle1: "Põe o HorseConnex no teu ecrã principal",
    subtitle2: "como uma app a sério! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Toca no menu ⋮ no canto superior direito do teu navegador',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Escolhe ',
    androidStep2bold: '"Adicionar ao ecrã principal"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Confirma com ',
    stepFinalBold: '"Adicionar"',
    stepFinalPost: " e está pronto! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Importante",
    iosWarningMid: ": usa o ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (não o Chrome) no iPhone",
    iosStep1Pre: 'Toca no botão ',
    iosStep1Bold: "Partilhar",
    iosStep1Post: " em baixo ⬆️",
    iosStep2Pre: 'Desliza para baixo e escolhe ',
    iosStep2Bold: '"Adicionar ao ecrã principal"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Porquê instalar?",
    benefit1: "✓ Acesso rápido a partir do teu ecrã principal",
    benefit2: "✓ Abre como uma app a sério",
    benefit3: "✓ Já não precisas de navegar no browser",
    later: "Mais tarde",
    gotIt: "Percebi ✓"
  },
  nl: {
    title: "🐴 Hé! Voeg me toe!",
    subtitle1: "Zet HorseConnex op je startscherm",
    subtitle2: "als een echte app! ✨",
    android: "📱 Android",
    iphone: "🍎 iPhone",
    androidStep1: 'Tik op het menu ⋮ rechtsboven in je browser',
    androidStep1Bold: "⋮",
    androidStep2pre: 'Kies ',
    androidStep2bold: '"Toevoegen aan startscherm"',
    androidStep2post: ' 🏠',
    stepFinalPre: 'Bevestig met ',
    stepFinalBold: '"Toevoegen"',
    stepFinalPost: " en klaar is kees! 🎉",
    iosWarningPre: "💡 ",
    iosWarningBold1: "Belangrijk",
    iosWarningMid: ": gebruik ",
    iosWarningBold2: "Safari",
    iosWarningPost: " (niet Chrome) op iPhone",
    iosStep1Pre: 'Tik op de knop ',
    iosStep1Bold: "Delen",
    iosStep1Post: " onderaan ⬆️",
    iosStep2Pre: 'Scrol naar beneden en kies ',
    iosStep2Bold: '"Zet op beginscherm"',
    iosStep2Post: " ➕",
    benefitsTitle: "✨ Waarom installeren?",
    benefit1: "✓ Snelle toegang vanaf je startscherm",
    benefit2: "✓ Opent als een echte app",
    benefit3: "✓ Niet meer door de browser navigeren",
    later: "Later",
    gotIt: "Begrepen ✓"
  }
};

const COOKIE_TEXTS = {
  fr: {
    title: "On utilise des cookies",
    message: "Pour améliorer ton expérience et te proposer le meilleur service. Tu choisis ce que tu autorises ! 🐴",
    acceptAll: "✓ Tout accepter",
    customize: "⚙️ Personnaliser",
    refuse: "Refuser",
    settingsTitle: "🍪 Personnaliser les cookies",
    settingsMessage: "Choisis quels cookies tu autorises. Les cookies essentiels sont toujours activés (nécessaires au fonctionnement de l'app).",
    essentialName: "Essentiels",
    alwaysActive: "Toujours actifs",
    essentialDesc: "Connexion, sécurité, préférences linguistiques. Indispensables au bon fonctionnement.",
    analyticsName: "Analytiques",
    analyticsDesc: "Nous aident à comprendre comment tu utilises l'app pour l'améliorer (statistiques anonymes).",
    marketingName: "Marketing",
    marketingDesc: "Pour te proposer du contenu personnalisé (ex: annonces qui pourraient t'intéresser).",
    refuseAll: "Refuser tout",
    savePrefs: "Enregistrer mes choix"
  },
  en: {
    title: "We use cookies",
    message: "To improve your experience and provide the best service. You choose what you allow! 🐴",
    acceptAll: "✓ Accept all",
    customize: "⚙️ Customize",
    refuse: "Refuse",
    settingsTitle: "🍪 Customize cookies",
    settingsMessage: "Choose which cookies you allow. Essential cookies are always on (required for the app to work).",
    essentialName: "Essential",
    alwaysActive: "Always on",
    essentialDesc: "Login, security, language preferences. Required for proper functioning.",
    analyticsName: "Analytics",
    analyticsDesc: "Help us understand how you use the app to improve it (anonymous statistics).",
    marketingName: "Marketing",
    marketingDesc: "To offer you personalized content (e.g. ads that might interest you).",
    refuseAll: "Refuse all",
    savePrefs: "Save my choices"
  },
  de: {
    title: "Wir nutzen Cookies",
    message: "Um deine Erfahrung zu verbessern und dir den besten Service zu bieten. Du entscheidest, was du erlaubst! 🐴",
    acceptAll: "✓ Alle akzeptieren",
    customize: "⚙️ Anpassen",
    refuse: "Ablehnen",
    settingsTitle: "🍪 Cookies anpassen",
    settingsMessage: "Wähle, welche Cookies du erlaubst. Notwendige Cookies sind immer aktiv (für die Funktion der App erforderlich).",
    essentialName: "Notwendig",
    alwaysActive: "Immer aktiv",
    essentialDesc: "Anmeldung, Sicherheit, Spracheinstellungen. Unverzichtbar für die Funktion.",
    analyticsName: "Analyse",
    analyticsDesc: "Helfen uns zu verstehen, wie du die App nutzt, um sie zu verbessern (anonyme Statistiken).",
    marketingName: "Marketing",
    marketingDesc: "Um dir personalisierte Inhalte anzubieten (z. B. Anzeigen, die dich interessieren könnten).",
    refuseAll: "Alle ablehnen",
    savePrefs: "Auswahl speichern"
  },
  es: {
    title: "Usamos cookies",
    message: "Para mejorar tu experiencia y ofrecerte el mejor servicio. ¡Tú eliges qué permites! 🐴",
    acceptAll: "✓ Aceptar todo",
    customize: "⚙️ Personalizar",
    refuse: "Rechazar",
    settingsTitle: "🍪 Personalizar las cookies",
    settingsMessage: "Elige qué cookies permites. Las cookies esenciales están siempre activas (necesarias para el funcionamiento de la app).",
    essentialName: "Esenciales",
    alwaysActive: "Siempre activas",
    essentialDesc: "Conexión, seguridad, preferencias de idioma. Indispensables para el buen funcionamiento.",
    analyticsName: "Analíticas",
    analyticsDesc: "Nos ayudan a entender cómo usas la app para mejorarla (estadísticas anónimas).",
    marketingName: "Marketing",
    marketingDesc: "Para ofrecerte contenido personalizado (ej: anuncios que podrían interesarte).",
    refuseAll: "Rechazar todo",
    savePrefs: "Guardar mis preferencias"
  },
  it: {
    title: "Usiamo i cookie",
    message: "Per migliorare la tua esperienza e offrirti il miglior servizio. Tu scegli cosa permetti! 🐴",
    acceptAll: "✓ Accetta tutto",
    customize: "⚙️ Personalizza",
    refuse: "Rifiuta",
    settingsTitle: "🍪 Personalizza i cookie",
    settingsMessage: "Scegli quali cookie permetti. I cookie essenziali sono sempre attivi (necessari al funzionamento dell'app).",
    essentialName: "Essenziali",
    alwaysActive: "Sempre attivi",
    essentialDesc: "Accesso, sicurezza, preferenze linguistiche. Indispensabili per il corretto funzionamento.",
    analyticsName: "Analitici",
    analyticsDesc: "Ci aiutano a capire come usi l'app per migliorarla (statistiche anonime).",
    marketingName: "Marketing",
    marketingDesc: "Per offrirti contenuti personalizzati (es. annunci che potrebbero interessarti).",
    refuseAll: "Rifiuta tutto",
    savePrefs: "Salva le mie preferenze"
  },
  pt: {
    title: "Usamos cookies",
    message: "Para melhorar a tua experiência e oferecer o melhor serviço. Tu escolhes o que permites! 🐴",
    acceptAll: "✓ Aceitar tudo",
    customize: "⚙️ Personalizar",
    refuse: "Recusar",
    settingsTitle: "🍪 Personalizar cookies",
    settingsMessage: "Escolhe que cookies permites. Os cookies essenciais estão sempre ativos (necessários para o funcionamento da app).",
    essentialName: "Essenciais",
    alwaysActive: "Sempre ativos",
    essentialDesc: "Início de sessão, segurança, preferências linguísticas. Indispensáveis para o bom funcionamento.",
    analyticsName: "Analíticos",
    analyticsDesc: "Ajudam-nos a perceber como usas a app para a melhorarmos (estatísticas anónimas).",
    marketingName: "Marketing",
    marketingDesc: "Para te oferecer conteúdo personalizado (ex: anúncios que possam interessar-te).",
    refuseAll: "Recusar tudo",
    savePrefs: "Guardar as minhas preferências"
  },
  nl: {
    title: "We gebruiken cookies",
    message: "Om je ervaring te verbeteren en je de beste service te bieden. Jij kiest wat je toestaat! 🐴",
    acceptAll: "✓ Alles accepteren",
    customize: "⚙️ Aanpassen",
    refuse: "Weigeren",
    settingsTitle: "🍪 Cookies aanpassen",
    settingsMessage: "Kies welke cookies je toestaat. Essentiële cookies staan altijd aan (nodig om de app te laten werken).",
    essentialName: "Essentieel",
    alwaysActive: "Altijd aan",
    essentialDesc: "Inloggen, beveiliging, taalvoorkeuren. Onmisbaar voor een goede werking.",
    analyticsName: "Analytisch",
    analyticsDesc: "Helpen ons te begrijpen hoe je de app gebruikt, zodat we ze kunnen verbeteren (anonieme statistieken).",
    marketingName: "Marketing",
    marketingDesc: "Om je gepersonaliseerde inhoud te tonen (bijv. advertenties die je kunnen interesseren).",
    refuseAll: "Alles weigeren",
    savePrefs: "Mijn keuzes opslaan"
  }
};

export function InstallAppPopup({ onClose, onPermanentClose, lang = "en" }) {
  const tx = INSTALL_TEXTS[lang] || INSTALL_TEXTS.en;
  const [os, setOs] = useState("android"); // "android" ou "ios"
  
  useEffect(() => {
    // Detecter l'OS
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod")) {
      setOs("ios");
    } else {
      setOs("android");
    }
  }, []);
  
  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,.7)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18,
      backdropFilter: "blur(4px)"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 18,
        maxWidth: 380,
        width: "100%",
        padding: 0,
        position: "relative",
        boxShadow: "0 20px 50px rgba(0,0,0,.4)",
        overflow: "hidden",
        maxHeight: "90vh",
        overflowY: "auto"
      }}>
        {/* Header avec logo */}
        <div style={{
          background: "linear-gradient(135deg, #1A1A2E 0%, #2D1B4E 50%, #C8001A 100%)",
          padding: "26px 22px 22px",
          textAlign: "center",
          position: "relative"
        }}>
          {/* Croix de fermeture */}
          <button onClick={onClose} style={{
            position: "absolute",
            top: 12, right: 12,
            background: "rgba(255,255,255,.2)",
            border: "none",
            borderRadius: "50%",
            width: 32, height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#fff",
            fontSize: 18,
            fontWeight: 600
          }}>×</button>
          
          {/* Logo */}
          <img src={LOGO} alt="HorseConnex" style={{
            width: 90,
            height: 90,
            objectFit: "contain",
            filter: "drop-shadow(0 4px 12px rgba(0,0,0,.3))",
            marginBottom: 8
          }}/>
          
          {/* Titre */}
          <div style={{
            fontFamily: "var(--fh)",
            fontSize: 18,
            fontWeight: 800,
            color: "#fff",
            letterSpacing: .5,
            marginBottom: 4
          }}>
            {tx.title}
          </div>
          <div style={{
            fontSize: 12,
            color: "rgba(255,255,255,.85)",
            lineHeight: 1.5
          }}>
            {tx.subtitle1}<br/>
            {tx.subtitle2}
          </div>
        </div>
        
        {/* Switch OS */}
        <div style={{
          display: "flex",
          background: "var(--bg)",
          padding: 4,
          margin: 16,
          borderRadius: 10,
          border: "1px solid var(--border)"
        }}>
          <button onClick={()=>setOs("android")} style={{
            flex: 1,
            padding: "8px",
            background: os==="android" ? "#fff" : "transparent",
            border: "none",
            borderRadius: 7,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "var(--fh)",
            color: os==="android" ? "var(--red)" : "var(--muted)",
            boxShadow: os==="android" ? "0 1px 3px rgba(0,0,0,.1)" : "none",
            transition: "all .15s"
          }}>{tx.android}</button>
          <button onClick={()=>setOs("ios")} style={{
            flex: 1,
            padding: "8px",
            background: os==="ios" ? "#fff" : "transparent",
            border: "none",
            borderRadius: 7,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "var(--fh)",
            color: os==="ios" ? "var(--red)" : "var(--muted)",
            boxShadow: os==="ios" ? "0 1px 3px rgba(0,0,0,.1)" : "none",
            transition: "all .15s"
          }}>{tx.iphone}</button>
        </div>
        
        {/* Etapes selon l'OS */}
        <div style={{padding: "0 18px 18px"}}>
          {os === "android" ? (
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>1</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.androidStep1.split(tx.androidStep1Bold)[0]}<strong style={{fontSize: 16}}>{tx.androidStep1Bold}</strong>{tx.androidStep1.split(tx.androidStep1Bold)[1] || ''}
                </div>
              </div>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>2</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.androidStep2pre}<strong>{tx.androidStep2bold}</strong>{tx.androidStep2post}
                </div>
              </div>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>3</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.stepFinalPre}<strong>{tx.stepFinalBold}</strong>{tx.stepFinalPost}
                </div>
              </div>
            </div>
          ) : (
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>
              <div style={{
                background: "rgba(245,166,35,.1)",
                border: "1px solid rgba(245,166,35,.3)",
                padding: 10, borderRadius: 10,
                fontSize: 11.5, color: "#A35207", lineHeight: 1.5
              }}>
                {tx.iosWarningPre}<strong>{tx.iosWarningBold1}</strong>{tx.iosWarningMid}<strong>{tx.iosWarningBold2}</strong>{tx.iosWarningPost}
              </div>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>1</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.iosStep1Pre}<strong>{tx.iosStep1Bold}</strong>{tx.iosStep1Post.replace('⬆️','')}<span style={{fontSize: 16}}>⬆️</span>
                </div>
              </div>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>2</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.iosStep2Pre}<strong>{tx.iosStep2Bold}</strong>{tx.iosStep2Post}
                </div>
              </div>
              <div style={{
                display: "flex", gap: 10, alignItems: "flex-start",
                background: "var(--bg)", padding: 12, borderRadius: 10
              }}>
                <div style={{
                  background: "var(--red)", color: "#fff",
                  width: 26, height: 26, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: 13, flexShrink: 0,
                  fontFamily: "var(--fh)"
                }}>3</div>
                <div style={{flex: 1, fontSize: 13, color: "var(--text)", lineHeight: 1.5}}>
                  {tx.stepFinalPre}<strong>{tx.stepFinalBold}</strong>{tx.stepFinalPost}
                </div>
              </div>
            </div>
          )}
          
          {/* Avantages */}
          <div style={{
            marginTop: 14,
            padding: 12,
            background: "linear-gradient(135deg, rgba(6,95,70,.08) 0%, rgba(6,95,70,.03) 100%)",
            border: "1px solid rgba(6,95,70,.15)",
            borderRadius: 10
          }}>
            <div style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#065F46",
              marginBottom: 6,
              letterSpacing: .5,
              textTransform: "uppercase",
              fontFamily: "var(--fh)"
            }}>{tx.benefitsTitle}</div>
            <div style={{fontSize: 12, color: "var(--text)", lineHeight: 1.6}}>
              {tx.benefit1}<br/>
              {tx.benefit2}<br/>
              {tx.benefit3}
            </div>
          </div>
          
          {/* Boutons */}
          <div style={{display: "flex", gap: 8, marginTop: 16}}>
            <button onClick={onClose} style={{
              flex: 1,
              padding: "12px",
              background: "var(--bg)",
              border: "1.5px solid var(--border)",
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "var(--text)"
            }}>{tx.later}</button>
            <button onClick={onPermanentClose} style={{
              flex: 1.5,
              padding: "12px",
              background: "var(--red)",
              border: "none",
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(200,0,26,.3)"
            }}>{tx.gotIt}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// === CookieBanner ===
// Bandeau RGPD/CCPA pour consentement cookies
export function CookieBanner({ onClose, lang = "en" }) {
  const tx = COOKIE_TEXTS[lang] || COOKIE_TEXTS.en;
  const [showSettings, setShowSettings] = useState(false);
  const [prefs, setPrefs] = useState({
    essential: true, // Toujours actifs (necessaires au fonctionnement)
    analytics: false,
    marketing: false,
  });
  
  const acceptAll = () => {
    const allAccepted = { essential: true, analytics: true, marketing: true };
    try {
      localStorage.setItem("hc_cookies_consent", JSON.stringify({
        ...allAccepted,
        timestamp: Date.now(),
        version: "1.0"
      }));
    } catch(e){}
    onClose();
  };
  
  const acceptEssential = () => {
    try {
      localStorage.setItem("hc_cookies_consent", JSON.stringify({
        essential: true,
        analytics: false,
        marketing: false,
        timestamp: Date.now(),
        version: "1.0"
      }));
    } catch(e){}
    onClose();
  };
  
  const savePrefs = () => {
    try {
      localStorage.setItem("hc_cookies_consent", JSON.stringify({
        ...prefs,
        timestamp: Date.now(),
        version: "1.0"
      }));
    } catch(e){}
    onClose();
  };
  
  if (showSettings) {
    return (
      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,.7)",
        zIndex: 10001,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 18,
        backdropFilter: "blur(4px)"
      }}>
        <div style={{
          background: "#fff",
          borderRadius: 16,
          maxWidth: 420,
          width: "100%",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow: "0 20px 50px rgba(0,0,0,.4)"
        }}>
          {/* Header */}
          <div style={{
            padding: "20px 20px 14px",
            borderBottom: "1px solid var(--border)"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 6
            }}>
              <div style={{
                fontFamily: "var(--fh)",
                fontSize: 18,
                fontWeight: 800,
                color: "var(--text)"
              }}>{tx.settingsTitle}</div>
              <button onClick={()=>setShowSettings(false)} style={{
                background: "var(--bg)",
                border: "none",
                borderRadius: "50%",
                width: 30, height: 30,
                cursor: "pointer",
                fontSize: 16,
                color: "var(--muted)"
              }}>×</button>
            </div>
            <div style={{fontSize: 11.5, color: "var(--muted)", lineHeight: 1.5}}>
              {tx.settingsMessage}
            </div>
          </div>
          
          {/* Categories */}
          <div style={{padding: "14px 20px"}}>
            
            {/* Essentiels */}
            <div style={{
              padding: "12px 14px",
              background: "rgba(6,95,70,.05)",
              border: "1px solid rgba(6,95,70,.2)",
              borderRadius: 10,
              marginBottom: 10
            }}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6}}>
                <div style={{display: "flex", alignItems: "center", gap: 6}}>
                  <span style={{fontSize: 16}}>🔒</span>
                  <span style={{fontSize: 13, fontWeight: 700, color: "var(--text)"}}>{tx.essentialName}</span>
                </div>
                <div style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#065F46",
                  letterSpacing: .5,
                  textTransform: "uppercase",
                  fontFamily: "var(--fh)"
                }}>{tx.alwaysActive}</div>
              </div>
              <div style={{fontSize: 11.5, color: "var(--muted)", lineHeight: 1.5}}>
                {tx.essentialDesc}
              </div>
            </div>
            
            {/* Analytics */}
            <div onClick={()=>setPrefs(p=>({...p, analytics: !p.analytics}))} style={{
              padding: "12px 14px",
              background: prefs.analytics ? "rgba(124,58,237,.08)" : "var(--bg)",
              border: "1.5px solid " + (prefs.analytics ? "rgba(124,58,237,.4)" : "var(--border)"),
              borderRadius: 10,
              marginBottom: 10,
              cursor: "pointer",
              transition: "all .15s"
            }}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6}}>
                <div style={{display: "flex", alignItems: "center", gap: 6}}>
                  <span style={{fontSize: 16}}>📊</span>
                  <span style={{fontSize: 13, fontWeight: 700, color: "var(--text)"}}>{tx.analyticsName}</span>
                </div>
                <div style={{
                  width: 38, height: 22,
                  background: prefs.analytics ? "#7C3AED" : "var(--border)",
                  borderRadius: 11,
                  position: "relative",
                  transition: "all .2s"
                }}>
                  <div style={{
                    position: "absolute",
                    top: 2,
                    left: prefs.analytics ? 18 : 2,
                    width: 18, height: 18,
                    background: "#fff",
                    borderRadius: "50%",
                    transition: "all .2s",
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                  }}/>
                </div>
              </div>
              <div style={{fontSize: 11.5, color: "var(--muted)", lineHeight: 1.5}}>
                {tx.analyticsDesc}
              </div>
            </div>
            
            {/* Marketing */}
            <div onClick={()=>setPrefs(p=>({...p, marketing: !p.marketing}))} style={{
              padding: "12px 14px",
              background: prefs.marketing ? "rgba(245,166,35,.08)" : "var(--bg)",
              border: "1.5px solid " + (prefs.marketing ? "rgba(245,166,35,.4)" : "var(--border)"),
              borderRadius: 10,
              marginBottom: 10,
              cursor: "pointer",
              transition: "all .15s"
            }}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6}}>
                <div style={{display: "flex", alignItems: "center", gap: 6}}>
                  <span style={{fontSize: 16}}>🎯</span>
                  <span style={{fontSize: 13, fontWeight: 700, color: "var(--text)"}}>{tx.marketingName}</span>
                </div>
                <div style={{
                  width: 38, height: 22,
                  background: prefs.marketing ? "#F5A623" : "var(--border)",
                  borderRadius: 11,
                  position: "relative",
                  transition: "all .2s"
                }}>
                  <div style={{
                    position: "absolute",
                    top: 2,
                    left: prefs.marketing ? 18 : 2,
                    width: 18, height: 18,
                    background: "#fff",
                    borderRadius: "50%",
                    transition: "all .2s",
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                  }}/>
                </div>
              </div>
              <div style={{fontSize: 11.5, color: "var(--muted)", lineHeight: 1.5}}>
                {tx.marketingDesc}
              </div>
            </div>
          </div>
          
          {/* Footer boutons */}
          <div style={{
            padding: "14px 20px 18px",
            borderTop: "1px solid var(--border)",
            display: "flex",
            gap: 8
          }}>
            <button onClick={acceptEssential} style={{
              flex: 1,
              padding: "11px",
              background: "var(--bg)",
              border: "1.5px solid var(--border)",
              borderRadius: 10,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "var(--text)"
            }}>{tx.refuseAll}</button>
            <button onClick={savePrefs} style={{
              flex: 1.5,
              padding: "11px",
              background: "var(--red)",
              border: "none",
              borderRadius: 10,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "#fff"
            }}>{tx.savePrefs}</button>
          </div>
        </div>
      </div>
    );
  }
  
  // Bandeau standard
  return (
    <div style={{
      position: "fixed",
      bottom: 0, left: 0, right: 0,
      zIndex: 10001,
      padding: 14,
      pointerEvents: "none"
    }}>
      <div style={{
        maxWidth: 420,
        margin: "0 auto",
        background: "#fff",
        borderRadius: 14,
        padding: 16,
        boxShadow: "0 -4px 20px rgba(0,0,0,.15), 0 8px 32px rgba(0,0,0,.1)",
        border: "1px solid var(--border)",
        pointerEvents: "auto"
      }}>
        <div style={{display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 12}}>
          <div style={{fontSize: 26, flexShrink: 0}}>🍪</div>
          <div style={{flex: 1}}>
            <div style={{
              fontFamily: "var(--fh)",
              fontSize: 14,
              fontWeight: 800,
              color: "var(--text)",
              marginBottom: 4
            }}>{tx.title}</div>
            <div style={{
              fontSize: 11.5,
              color: "var(--muted)",
              lineHeight: 1.5
            }}>
              {tx.message}
            </div>
          </div>
        </div>
        
        <div style={{display: "flex", flexDirection: "column", gap: 6}}>
          <button onClick={acceptAll} style={{
            padding: "11px",
            background: "var(--red)",
            border: "none",
            borderRadius: 10,
            fontSize: 12.5,
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "var(--fh)",
            color: "#fff",
            letterSpacing: .3
          }}>{tx.acceptAll}</button>
          
          <div style={{display: "flex", gap: 6}}>
            <button onClick={()=>setShowSettings(true)} style={{
              flex: 1,
              padding: "9px",
              background: "var(--bg)",
              border: "1.5px solid var(--border)",
              borderRadius: 10,
              fontSize: 11.5,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "var(--text)"
            }}>{tx.customize}</button>
            <button onClick={acceptEssential} style={{
              flex: 1,
              padding: "9px",
              background: "var(--bg)",
              border: "1.5px solid var(--border)",
              borderRadius: 10,
              fontSize: 11.5,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "var(--fh)",
              color: "var(--muted)"
            }}>{tx.refuse}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
